(() => {
  const toggle = document.querySelector('#NnMotionPaused');
  if (!toggle) return;

  const preferenceKey = 'nn-studio-motion-paused';
  try {
    toggle.checked = sessionStorage.getItem(preferenceKey) === 'true';
  } catch {
    // The current page control still works when storage is unavailable.
  }

  toggle.addEventListener('change', () => {
    try {
      sessionStorage.setItem(preferenceKey, String(toggle.checked));
    } catch {
      // The current page control still works when storage is unavailable.
    }
  });

  const edges = document.querySelector('[data-scroll-edges]');
  if (!edges) return;

  const page = document.scrollingElement || document.documentElement;
  const header = document.querySelector('.nn-section-header');
  let frame = 0;
  let previousTop = Math.max(0, page.scrollTop);

  function updateEdges() {
    frame = 0;
    const maxScroll = Math.max(0, page.scrollHeight - page.clientHeight);
    const top = Math.max(0, Math.min(page.scrollTop, maxScroll));
    const headerHeight = header?.offsetHeight || 0;
    const delta = top - previousTop;
    const strength = (distance) => Math.min(1, distance / 72);
    const keepHeaderOpen = header?.matches(':has(details[open], :focus-visible)');

    if (header) {
      if (top <= 4 || delta < -0.5 || keepHeaderOpen) {
        header.removeAttribute('data-scroll-hidden');
      } else if (top >= headerHeight && delta > 0.5) {
        header.setAttribute('data-scroll-hidden', '');
      }
    }

    previousTop = top;
    const visibleHeight = header?.hasAttribute('data-scroll-hidden') ? 0 : headerHeight;
    const topStrength = strength(top);
    const bottomStrength = strength(maxScroll - top) * (0.7 + 0.3 * topStrength);
    edges.style.setProperty('--nn-edge-top', topStrength.toFixed(3));
    edges.style.setProperty('--nn-edge-bottom', bottomStrength.toFixed(3));
    edges.style.setProperty('--nn-edge-header', visibleHeight + 'px');
  }

  function queueUpdate() {
    if (!frame) frame = window.requestAnimationFrame(updateEdges);
  }

  updateEdges();
  window.addEventListener('scroll', queueUpdate, { passive: true });
  window.addEventListener('resize', queueUpdate, { passive: true });
  window.addEventListener('pageshow', queueUpdate);
  header?.addEventListener('focusin', queueUpdate);
  header?.addEventListener('toggle', queueUpdate, true);
  if ('ResizeObserver' in window) {
    new ResizeObserver(queueUpdate).observe(document.body);
  }
})();
